import React, { PropsWithChildren } from 'react';
import isEmbedded from '../isEmbedded';

const HideWhenEmbedded = ({ children }: PropsWithChildren<unknown>) => {
  if (isEmbedded()) return null;
  return <>{children}</>;
};

export default HideWhenEmbedded;
